import React from "react";
import { redirectToApplication } from "go-core/utils/utils";
import { ConfigApi } from "../Api/types";

export class ConfigService {
	config: ConfigApi;
	private appsOldVersionTimestamp: Record<string, number>;

	constructor(config: ConfigApi) {
		this.config = config;
		this.appsOldVersionTimestamp = {
			GOSTOCK: new Date(2024, 4, 20, 0, 0, 0, 0).getTime(),
		};
	}

	get() {
		return this.config;
	}

	applications() {
		return this.config.apps;
	}

	getAppsOldVersionTimestamps() {
		return this.appsOldVersionTimestamp;
	}

	getRedirectUrl(appId: string, companyId: string) {
		const app = this.applications().filter((x) => x.id.toUpperCase() === appId.toUpperCase())[0];
		if (!app) return undefined;
		if (app.old) return app.url;
		return redirectToApplication(app.url, companyId);
	}

	getApp() {
		const url = window.location.href;
		return this.applications().find((app) => url.includes(app.id.toLowerCase()));
	}
}

export const ConfigContext = React.createContext<ConfigService>({} as ConfigService);
